// import { run } from './KenPrice/script';
import { run } from './Monolith/script';

run()